<template>
    <transition
        name="collapse"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
    >
        <slot/>
    </transition>
</template>
<script>
/* eslint no-param-reassign: 'off' */

export default {
    name: 'TransitionCollapse',
    methods: {
        enter (el) {
            el.style.height = 'auto';
            const { height } = getComputedStyle(el);

            el.style.height = 0;

            requestAnimationFrame(() => {
                el.style.height = height;
            });
        },
        afterEnter (el) {
            el.style.height = 'auto';
        },
        leave (el) {
            const { height } = getComputedStyle(el);

            el.style.height = height;

            requestAnimationFrame(() => {
                el.style.height = 0;
            });
        },
    },
};
</script>
<style lang="scss" scoped>
* {
    will-change: height;
}
</style>
